export default {"src":"/_next/static/image/public/images/flags/flag_236.4378149ca000f2b291a58e2b842b16f4.svg","height":17,"width":25};